export type TaskCalendarOption = {
  id: string;
  name: string;
};

type TaskCalendarPickerProps = {
  options: TaskCalendarOption[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
};

export function TaskCalendarPicker({
  options,
  selectedIds,
  onChange,
  disabled = false,
}: TaskCalendarPickerProps) {
  function toggle(id: string): void {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((item) => item !== id));
      return;
    }

    onChange([...selectedIds, id]);
  }

  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-medium text-slate-700">Calendários</legend>
      <p className="text-xs text-slate-500">
        Marque onde a tarefa deve aparecer. Ela fica visível quando o calendário correspondente está ligado na agenda.
      </p>
      <div className="space-y-1">
        {options.map((option) => (
          <label key={option.id} className="flex items-center gap-2 text-sm text-slate-700">
            <input
              type="checkbox"
              className="rounded border-slate-300"
              checked={selectedIds.includes(option.id)}
              disabled={disabled}
              onChange={() => toggle(option.id)}
            />
            <span className="truncate">{option.name}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
